export const sofiaMladostTranslations = {
  en: {
    breadcrumb: { home: 'Home', locations: 'Locations', mladost: 'Sofia, Mladost' },
    hero: {
      badge: 'Sofia, Mladost',
      heading: 'Sports Hall Levski Sofia',
      subheading: 'Modern Basketball & Volleyball Training Facility',
      basketball: 'Basketball',
      volleyball: 'Volleyball',
      district: 'Sofia, Mladost district',
      spectators: 'Up to 2,000 spectators',
      sportsList: 'Basketball, Volleyball',
      stars: '5/5 stars',
      bookFacility: 'Book This Facility',
    },
    overview: {
      heading: 'Facility Overview',
      cards: [
        { heading: 'Facility Type', content: 'Modern Sports Hall', subtext: 'Only facility of its kind in Bulgaria' },
        { heading: 'Capacity', content: '2,000 Spectators', subtext: 'Professional seating arrangement' },
        { heading: 'Surface', content: 'Premium Hardwood', subtext: 'Competition-grade flooring' },
        { heading: 'Certification', content: 'Professional Standard', subtext: 'Meets international requirements' },
      ],
    },
    about: {
      heading: 'About Sports Hall Levski Sofia',
      description: "Sports Hall 'Levski Sofia' is a modern sports hall and the only facility of its kind in Bulgaria. Located in the Mladost district of Sofia, this state-of-the-art venue features professional basketball and volleyball courts equipped with the latest technology and amenities.",
      keyHighlights: 'Key Highlights',
      highlights: [
        'Only modern sports hall of this caliber in Bulgaria',
        'Professional-grade basketball court with international standards',
        'Regulation volleyball court with premium net systems',
        'State-of-the-art lighting and ventilation systems',
        'Modern locker rooms and athlete facilities',
        'Spectator seating for up to 2,000 people',
        'Equipment storage and rental services',
        'Ideal for training camps, tournaments, and competitions',
      ],
      testimonial: '"The perfect training environment for professional teams seeking world-class facilities in the heart of Sofia."',
      testimonialAttribution: 'Champion Maker Team',
    },
    sports: {
      heading: 'Available Sports & Activities',
      basketball: 'Basketball',
      basketballDesc: 'Professional basketball court meeting FIBA standards with premium hardwood flooring, electronic scoreboards, and shot clocks.',
      viewSpecs: 'View Specifications',
      hideSpecs: 'Hide Specifications',
      courtSpecs: 'Court Specifications:',
      basketballSpecsList: ['Court dimensions: 28m x 15m (FIBA standard)', 'Surface: Premium maple hardwood', 'Hoops: Professional breakaway rims', 'Markings: International standard', 'Lighting: Professional LED system'],
      idealFor: 'Ideal For:',
      basketballIdealFor: ['Professional team training camps', 'Youth development programs', 'Tournaments and competitions', 'Skill development sessions', 'Pre-season preparations'],
      volleyball: 'Volleyball',
      volleyballDesc: 'Regulation volleyball court with professional net systems, electronic scoring, and optimal floor spacing for competitive play.',
      volleyballSpecsList: ['Court dimensions: 18m x 9m (FIVB standard)', 'Surface: Premium hardwood', 'Net system: Professional height-adjustable', 'Antenna: International standard', 'Lighting: Optimal for indoor play'],
      volleyballIdealFor: ['National team training camps', 'Club team preparations', 'Beach volleyball indoor transition', 'Tournament hosting', 'Year-round training programs'],
    },
    amenities: {
      heading: 'World-Class Facilities & Amenities',
      items: [
        { title: 'Modern Locker Rooms', desc: 'Spacious changing facilities with showers, lockers, and benches' },
        { title: 'Equipment Storage', desc: 'Secure storage areas for sports equipment and personal belongings' },
        { title: 'Spectator Seating', desc: 'Comfortable seating for up to 2,000 spectators with excellent court views' },
        { title: 'Parking Available', desc: 'Convenient parking facilities for teams and visitors' },
        { title: 'Equipment Rental', desc: 'Basketball and volleyball equipment available for rent' },
        { title: 'WiFi Available', desc: 'High-speed wireless internet throughout the facility' },
        { title: 'Cafeteria Services', desc: 'On-site refreshments and meal options available' },
        { title: 'Medical Facilities', desc: 'First aid and medical assistance room equipped for emergencies' },
        { title: 'Sound System', desc: 'Professional audio system for announcements and music' },
        { title: 'Electronic Scoreboards', desc: 'Digital scoreboards and shot clocks for professional play' },
        { title: 'Professional Lighting', desc: 'LED lighting system optimized for sports and broadcasting' },
        { title: 'Climate Control', desc: 'Modern HVAC system maintaining optimal training conditions' },
      ],
    },
    gallery: {
      heading: 'Facility Gallery',
      subheading: 'Explore our world-class training environment',
    },
    galleryImages: { heading: 'Facility Gallery Images' },
    access: {
      heading: 'Location & How to Get Here',
      address: 'Address',
      addressLine1: 'Sports Hall Levski Sofia',
      addressLine2: 'Mladost District',
      addressLine3: 'Sofia, Bulgaria',
      getDirections: 'Get Directions',
      byCar: 'By Car',
      car1: 'Parking available on-site',
      car2: 'Easy access from main roads',
      car3: 'Approximately 15 minutes from Sofia city center',
      byBus: 'By Public Transport',
      bus1: 'Metro: Mladost Station (10 min walk)',
      bus2: 'Bus lines available',
      bus3: 'Tram lines available',
      fromAirport: 'From Airport',
      airport1: 'Distance: Approximately 12 km from Sofia Airport',
      airport2: 'Transfer time: 20-25 minutes by car',
      airport3: 'We provide airport transfer services',
      nearbyLandmarks: 'Nearby Landmarks',
      nearby1: 'Shopping Mall Paradise Center - 5 min drive',
      nearby2: 'Mladost Metro Station - 10 min walk',
    },
    pricing: {
      heading: 'Pricing & Availability',
      flexiblePricing: 'Flexible Pricing Options',
      pricingVaries: 'Pricing varies based on:',
      factors: [
        'Duration of booking (hourly, half-day, full-day)',
        'Season and demand',
        'Number of courts needed',
        'Additional services required',
        'Equipment rental needs',
        'Support staff requirements',
      ],
      pricingNote: 'For detailed pricing and package options, please contact us with your specific requirements.',
      whatsIncluded: "What's Included:",
      included: [
        'Court access for specified time',
        'Basic equipment (balls, nets)',
        'Locker room facilities',
        'Lighting and climate control',
        'Sound system access',
        'On-site staff support',
      ],
      optionalAddons: 'Optional Add-ons:',
      addons: [
        'Equipment rental (additional basketballs, volleyball sets)',
        'Extended hours',
        'Referee services',
        'Video recording setup',
        'Coaching staff',
        'Medical support',
      ],
      requestQuote: 'Request a Quote',
    },
    testimonials: {
      heading: 'What Teams Say About Training Here',
      items: [
        { quote: "Sports Hall Levski Sofia provided the perfect environment for our basketball training camp. The facilities are top-notch and the staff was incredibly helpful.", name: "Coach Martin Petrov", date: "August 2025" },
        { quote: "Excellent hardwood court quality and modern facilities. Our volleyball team had an outstanding training experience. Highly recommend!", name: "Anna Ivanova", date: "July 2025" },
        { quote: "The only facility of this caliber in Bulgaria. Perfect for professional training camps with all the amenities our team needed.", name: "Coach Thomas Weber", date: "June 2025" },
        { quote: "Great location in Sofia, easy access, and professional-grade equipment. The spectator seating also made it perfect for hosting friendly matches.", name: "Sarah Mitchell", date: "May 2025" },
      ],
    },
    similar: {
      heading: 'Explore Other Locations in Sofia',
      viewDetails: 'View Details',
      locations: [
        { name: 'National Sports Academy', location: 'Sofia, NSA', badge: 'Athletics', description: 'World-class athletics and track & field facilities', path: '/locations/sofia-nsa' },
        { name: 'Boyana Sports Complex', location: 'Sofia, Boyana', badge: 'Multi-Sport', description: 'Comprehensive multi-sport training facility', path: '/locations/sofia-boyana' },
        { name: 'Plovdiv Aquatic Center', location: 'Plovdiv', badge: 'Swimming', description: 'Olympic-size swimming pool and aquatic center', path: '/locations/plovdiv' },
      ],
    },
    faq: {
      heading: 'Frequently Asked Questions',
      items: [
        { question: 'What are the court dimensions?', answer: 'The basketball court is 28m x 15m (FIBA standard) and the volleyball court is 18m x 9m (FIVB standard), both with premium hardwood flooring.' },
        { question: 'Is equipment provided?', answer: 'Basic equipment (balls, nets) is included. Additional equipment such as training aids, cones, and specialized gear can be rented separately.' },
        { question: 'Can we book both courts simultaneously?', answer: 'Yes, both the basketball and volleyball courts can be booked together for multi-sport training camps or tournaments.' },
        { question: 'What are the facility operating hours?', answer: 'The facility operates from 7:00 AM to 11:00 PM daily. Special arrangements can be made for extended hours upon request.' },
        { question: 'Is there accommodation on-site?', answer: 'Accommodation is not available on-site at this location, but we can arrange lodging at nearby 4-star hotels or at our Boyana facility which offers on-site rooms.' },
        { question: 'How far is it from Sofia Airport?', answer: 'Sports Hall Levski Sofia is approximately 12 km from Sofia Airport, about 20-25 minutes by car. We provide airport transfer services.' },
        { question: 'Can we host tournaments here?', answer: 'Absolutely! The facility is equipped for hosting tournaments and competitions with spectator seating for up to 2,000 people, scoreboards, and all necessary equipment.' },
        { question: 'Are meals available?', answer: 'The facility has a cafeteria providing refreshments and light meals. For full meal plans, we can coordinate catering services as part of your training camp package.' },
        { question: 'Is the facility accessible for people with disabilities?', answer: 'Yes, the facility is wheelchair accessible with appropriate facilities for athletes and spectators with disabilities.' },
        { question: 'Can we record training sessions?', answer: 'Yes, video recording is allowed. We can also arrange professional recording equipment and camera positions upon request.' },
      ],
    },
    cta: {
      heading: 'Ready to Book Sports Hall Levski Sofia?',
      subheading: 'Contact us to reserve your training dates',
      sendInquiry: 'Send a quick inquiry',
      requestInfo: 'Request Information',
      speakWithTeam: 'Speak with our team',
      getCompletePackage: 'Get a complete package',
      bookCompletePackage: 'Book Complete Package',
      ctaCallNow: 'Call Now',
    },
  },
  ar: {
    breadcrumb: { home: 'الرئيسية', locations: 'المواقع', mladost: 'صوفيا، ملادوست' },
    hero: {
      badge: 'صوفيا، ملادوست',
      heading: 'قاعة ليفسكي صوفيا الرياضية',
      subheading: 'منشأة تدريب حديثة لكرة السلة والطائرة',
      basketball: 'كرة السلة',
      volleyball: 'الكرة الطائرة',
      district: 'صوفيا، حي ملادوست',
      spectators: 'حتى 2000 متفرج',
      sportsList: 'كرة السلة، الكرة الطائرة',
      stars: '5/5 نجوم',
      bookFacility: 'احجز هذه المنشأة',
    },
    overview: {
      heading: 'نظرة عامة على المنشأة',
      cards: [
        { heading: 'نوع المنشأة', content: 'قاعة رياضية حديثة', subtext: 'المنشأة الوحيدة من نوعها في بلغاريا' },
        { heading: 'السعة', content: '2000 متفرج', subtext: 'ترتيب جلوس احترافي' },
        { heading: 'السطح', content: 'خشب متميز', subtext: 'أرضية بمعايير المنافسة' },
        { heading: 'الشهادة', content: 'معيار احترافي', subtext: 'يلبي المتطلبات الدولية' },
      ],
    },
    about: {
      heading: 'عن قاعة ليفسكي صوفيا الرياضية',
      description: "قاعة 'ليفسكي صوفيا' الرياضية هي قاعة رياضية حديثة والمنشأة الوحيدة من نوعها في بلغاريا. تقع في حي ملادوست في صوفيا، وتضم هذه المنشأة الحديثة ملاعب كرة سلة وطائرة احترافية مجهزة بأحدث التقنيات والمرافق.",
      keyHighlights: 'أبرز المميزات',
      highlights: [
        'القاعة الرياضية الحديثة الوحيدة بهذا المستوى في بلغاريا',
        'ملعب كرة سلة احترافي بمعايير دولية',
        'ملعب كرة طائرة نظامي بأنظمة شباك متميزة',
        'أنظمة إضاءة وتهوية حديثة',
        'غرف خلع ملابس ومرافق رياضية حديثة',
        'مقاعد لـ 2000 متفرج',
        'تخزين وتأجير معدات',
        'مثالي لمعسكرات التدريب والبطولات والمسابقات',
      ],
      testimonial: '"بيئة التدريب المثالية للفرق الاحترافية التي تبحث عن مرافق عالمية المستوى في قلب صوفيا."',
      testimonialAttribution: 'فريق صناع الأبطال',
    },
    sports: {
      heading: 'الرياضات والأنشطة المتاحة',
      basketball: 'كرة السلة',
      basketballDesc: 'ملعب كرة سلة احترافي يلبي معايير فيبا بأرضية خشب متميزة ولوحات نتائج إلكترونية وساعات رمي.',
      viewSpecs: 'عرض المواصفات',
      hideSpecs: 'إخفاء المواصفات',
      courtSpecs: 'مواصفات الملعب:',
      basketballSpecsList: ['أبعاد الملعب: 28م × 15م (معيار فيبا)', 'السطح: خشب قيقب متميز', 'السلال: حلقات احترافية قابلة للكسر', 'العلامات: معيار دولي', 'الإضاءة: نظام LED احترافي'],
      idealFor: 'مثالي لـ:',
      basketballIdealFor: ['معسكرات تدريب فرق احترافية', 'برامج تطوير الشباب', 'البطولات والمسابقات', 'جلسات تطوير المهارات', 'التحضيرات ما قبل الموسم'],
      volleyball: 'الكرة الطائرة',
      volleyballDesc: 'ملعب كرة طائرة نظامي بأنظمة شباك احترافية وتسجيل إلكتروني ومساحة أرضية مثالية للعب التنافسي.',
      volleyballSpecsList: ['أبعاد الملعب: 18م × 9م (معيار الاتحاد الدولي للكرة الطائرة)', 'السطح: خشب متميز', 'نظام الشباك: ارتفاع قابل للتعديل احترافي', 'الهوائي: معيار دولي', 'الإضاءة: مثالية للعب الداخلي'],
      volleyballIdealFor: ['معسكرات تدريب المنتخبات الوطنية', 'تحضيرات فرق الأندية', 'الانتقال من كرة الطائرة الشاطئية للداخلية', 'استضافة البطولات', 'برامج تدريب على مدار العام'],
    },
    amenities: {
      heading: 'مرافق وخدمات عالمية المستوى',
      items: [
        { title: 'غرف خلع ملابس حديثة', desc: 'مرافق تغيير واسعة مع دوش وخزائن ومقاعد' },
        { title: 'تخزين المعدات', desc: 'مناطق تخزين آمنة للمعدات الرياضية والممتلكات الشخصية' },
        { title: 'مقاعد للمتفرجين', desc: 'مقاعد مريحة حتى 2000 متفرج مع إطلالات ممتازة على الملعب' },
        { title: 'موقف سيارات متاح', desc: 'مرافق انتظار مريحة للفرق والزوار' },
        { title: 'تأجير المعدات', desc: 'معدات كرة سلة وطائرة متاحة للتأجير' },
        { title: 'واي فاي متاح', desc: 'إنترنت لاسلكي عالي السرعة في جميع أنحاء المنشأة' },
        { title: 'خدمات كافيتريا', desc: 'مرطبات ووجبات متاحة في الموقع' },
        { title: 'مرافق طبية', desc: 'غرفة إسعافات أولية ومساعدة طبية مجهزة للطوارئ' },
        { title: 'نظام صوت', desc: 'نظام صوت احترافي للإعلانات والموسيقى' },
        { title: 'لوحات نتائج إلكترونية', desc: 'لوحات نتائج رقمية وساعات رمي للعب الاحترافي' },
        { title: 'إضاءة احترافية', desc: 'نظام إضاءة LED محسّن للرياضات والبث' },
        { title: 'التحكم بالمناخ', desc: 'نظام تكييف حديث يحافظ على ظروف تدريب مثالية' },
      ],
    },
    gallery: {
      heading: 'معرض المنشأة',
      subheading: 'استكشف بيئة التدريب عالمية المستوى',
    },
    galleryImages: { heading: 'صور معرض المنشأة' },
    access: {
      heading: 'الموقع وكيفية الوصول',
      address: 'العنوان',
      addressLine1: 'قاعة ليفسكي صوفيا الرياضية',
      addressLine2: 'حي ملادوست',
      addressLine3: 'صوفيا، بلغاريا',
      getDirections: 'الحصول على الاتجاهات',
      byCar: 'بالسيارة',
      car1: 'موقف سيارات متاح في الموقع',
      car2: 'وصول سهل من الطرق الرئيسية',
      car3: 'حوالي 15 دقيقة من وسط صوفيا',
      byBus: 'بالنقل العام',
      bus1: 'مترو: محطة ملادوست (10 دقائق سيراً)',
      bus2: 'خطوط حافلات متاحة',
      bus3: 'خطوط ترام متاحة',
      fromAirport: 'من المطار',
      airport1: 'المسافة: حوالي 12 كم من مطار صوفيا',
      airport2: 'وقت النقل: 20-25 دقيقة بالسيارة',
      airport3: 'نوفر خدمات نقل من المطار',
      nearbyLandmarks: 'معالم قريبة',
      nearby1: 'مركز Paradise Center التجاري - 5 دقائق بالسيارة',
      nearby2: 'محطة مترو ملادوست - 10 دقائق سيراً',
    },
    pricing: {
      heading: 'الأسعار والتوفر',
      flexiblePricing: 'خيارات أسعار مرنة',
      pricingVaries: 'تختلف الأسعار حسب:',
      factors: [
        'مدة الحجز (بالساعة، نصف يوم، يوم كامل)',
        'الموسم والطلب',
        'عدد الملاعب المطلوبة',
        'الخدمات الإضافية المطلوبة',
        'احتياجات تأجير المعدات',
        'متطلبات طاقم الدعم',
      ],
      pricingNote: 'للحصول على تفاصيل الأسعار وخيارات الباقات، يرجى الاتصال بنا مع متطلباتك المحددة.',
      whatsIncluded: 'ما الذي يُدرج:',
      included: [
        'وصول للملعب للوقت المحدد',
        'معدات أساسية (كرات، شباك)',
        'مرافق غرف خلع الملابس',
        'إضاءة والتحكم بالمناخ',
        'وصول نظام الصوت',
        'دعم الطاقم في الموقع',
      ],
      optionalAddons: 'إضافات اختيارية:',
      addons: [
        'تأجير معدات (كرات سلة إضافية، مجموعات كرة طائرة)',
        'ساعات إضافية',
        'خدمات حكم',
        'إعداد تسجيل فيديو',
        'طاقم تدريب',
        'دعم طبي',
      ],
      requestQuote: 'طلب عرض أسعار',
    },
    testimonials: {
      heading: 'ماذا تقول الفرق عن التدريب هنا',
      items: [
        { quote: 'وفرت قاعة ليفسكي صوفيا الرياضية البيئة المثالية لمعسكر تدريب كرة السلة لدينا. المرافق من الطراز الأول والطاقم كان مفيداً بشكل لا يصدق.', name: 'المدرب مارتن بتروف', date: 'أغسطس 2025' },
        { quote: 'جودة ممتازة لأرضية الخشب الصلب ومرافق حديثة. حظي فريق الكرة الطائرة لدينا بتجربة تدريب متميزة. أوصي بشدة!', name: 'آنا إيفانوفا', date: 'يوليو 2025' },
        { quote: 'المنشأة الوحيدة بهذا المستوى في بلغاريا. مثالية لمعسكرات التدريب الاحترافية بجميع المرافق التي يحتاجها فريقنا.', name: 'المدرب توماس ويبر', date: 'يونيو 2025' },
        { quote: 'موقع رائع في صوفيا، وصول سهل، ومعدات احترافية. جعلت مقاعد المتفرجين منها مكاناً مثالياً لاستضافة مباريات ودية.', name: 'سارة ميتشل', date: 'مايو 2025' },
      ],
    },
    similar: {
      heading: 'استكشف مواقع أخرى في صوفيا',
      viewDetails: 'عرض التفاصيل',
      locations: [
        { name: 'الأكاديمية الوطنية للرياضة', location: 'صوفيا، الأكاديمية الوطنية', badge: 'ألعاب القوى', description: 'مرافق ألعاب قوى وجري وميدان عالمية المستوى', path: '/locations/sofia-nsa' },
        { name: 'المجمع الرياضي بويانا', location: 'صوفيا، بويانا', badge: 'متعدد الرياضات', description: 'منشأة تدريب رياضية شاملة', path: '/locations/sofia-boyana' },
        { name: 'مركز بلوفديف المائي', location: 'بلوفديف', badge: 'السباحة', description: 'مسبح أولمبي ومركز مائي', path: '/locations/plovdiv' },
      ],
    },
    faq: {
      heading: 'الأسئلة الشائعة',
      items: [
        { question: 'ما أبعاد الملعب؟', answer: 'ملعب كرة السلة 28م × 15م (معيار فيبا) وملعب الكرة الطائرة 18م × 9م (معيار الاتحاد الدولي للكرة الطائرة)، كلاهما بأرضية خشب متميزة.' },
        { question: 'هل يتم توفير المعدات؟', answer: 'المعدات الأساسية (كرات، شباك) مُدرجة. يمكن تأجير معدات إضافية مثل مساعدات التدريب والمخروطات والمعدات المتخصصة بشكل منفصل.' },
        { question: 'هل يمكننا حجز الملاعب معاً؟', answer: 'نعم، يمكن حجز ملاعب كرة السلة والطائرة معاً لمعسكرات تدريب أو بطولات متعددة الرياضات.' },
        { question: 'ما ساعات عمل المنشأة؟', answer: 'تعمل المنشأة من 7:00 صباحاً إلى 11:00 مساءً يومياً. يمكن ترتيب ساعات إضافية عند الطلب.' },
        { question: 'هل تتوفر إقامة في الموقع؟', answer: 'الإقامة غير متاحة في الموقع بهذا الموقع، لكن يمكننا ترتيب الإقامة في فنادق 4 نجوم قريبة أو في منشأة بويانا لدينا التي توفر غرفاً في الموقع.' },
        { question: 'كم تبعد عن مطار صوفيا؟', answer: 'قاعة ليفسكي صوفيا الرياضية على بعد حوالي 12 كم من مطار صوفيا، نحو 20-25 دقيقة بالسيارة. نوفر خدمات نقل من المطار.' },
        { question: 'هل يمكننا تنظيم بطولات هنا؟', answer: 'بالتأكيد! المنشأة مجهزة لاستضافة البطولات والمسابقات مع مقاعد لـ 2000 متفرج ولوحات نتائج وجميع المعدات اللازمة.' },
        { question: 'هل تتوفر وجبات؟', answer: 'المنشأة لديها كافيتريا توفر مرطبات ووجبات خفيفة. لخطط وجبات كاملة، يمكننا تنسيق خدمات التموين كجزء من باقة معسكر التدريب.' },
        { question: 'هل المنشأة متاحة لذوي الاحتياجات الخاصة؟', answer: 'نعم، المنشأة متاحة للكراسي المتحركة مع مرافق مناسبة للرياضيين والمتفرجين ذوي الاحتياجات الخاصة.' },
        { question: 'هل يمكننا تسجيل جلسات التدريب؟', answer: 'نعم، تسجيل الفيديو مسموح. يمكننا أيضاً ترتيب معدات تسجيل احترافية ومواضع كاميرا عند الطلب.' },
      ],
    },
    cta: {
      heading: 'مستعد لحجز قاعة ليفسكي صوفيا الرياضية؟',
      subheading: 'اتصل بنا لحجز مواعيد التدريب',
      sendInquiry: 'أرسل استفساراً سريعاً',
      requestInfo: 'طلب معلومات',
      speakWithTeam: 'تحدث مع فريقنا',
      getCompletePackage: 'احصل على باقة كاملة',
      bookCompletePackage: 'احجز الباقة الكاملة',
      ctaCallNow: 'اتصل الآن',
    },
  },
};
